import { Expression } from '../../../service/Expression'
import { ExpressionMetadata } from '../../../service/ExpressionMetadata'

const getExpressionMetadata = async ({ commit }, payload) => {
  try {
    const backEnd = Expression.build({})
    const res = await backEnd.getExpressionMetaData(payload.expressionId, payload.metric, payload.year, payload.subcategory, payload.child)
    return res.idexpression
  } catch (e) {
    throw e
  }
}
const getExpressionByMetadata = async ({ commit }, payload) => {
  try {
    const backEnd = ExpressionMetadata.build({})
    const res = await backEnd.getExpressionByMetadata(
      payload.seletor1,
      payload.year,
      payload.metric,
      payload.category_1,
      payload.category_2,
      payload.category_3,
      payload.category_4,
      payload.category_5,
      payload.category_6,
      payload.seletor2,
      payload.seletor3,
      payload.familyId
    )
    return res.idexpression
  } catch (e) {
    throw e
  }
}
const getExpressionMetadataByIdExpression = async ({ commit }, expressionId) => {
  try {
    const backEnd = Expression.build({})
    const res = await backEnd.getExpressionMetaDataByIdExpression(expressionId)
    if (res.status === 200) return res.data
    else throw new Error(`Ocorreu um erro ao obter metadados da expressão ${expressionId}.`)
  } catch (e) {
    throw e
  }
}
const getExpressionByMetadataMultiSelect = async ({ commit }, payload) => {
  try {
    const backEnd = ExpressionMetadata.build({})
    const res = await backEnd.getExpressionByMetadataMultiSelect(payload.seletor1, payload.year, payload.metric, payload.familyId)
    return res.idexpression
  } catch (e) {
    throw e
  }
}
const getExpressionByMetadataSingleSelect = async ({ commit }, payload) => {
  try {
    const backEnd = ExpressionMetadata.build({})
    const res = await backEnd.getExpressionByMetadataSingleSelect(payload.seletor1, payload.category_1, payload.year, payload.metric, payload.familyId)
    return res.idexpression
  } catch (e) {
    throw e
  }
}
const getIdExpByMetaData = async({ commit }, payload) => {
  try {
    const backEnd = Expression.build({})
    const res = await backEnd.getIdExpByMetaData(payload.seletor1, payload.year, payload.metric, payload.familyid, payload.category_1, payload.category_2, payload.category_3, payload.category_4, payload.category_5, payload.category_6, payload.seletor2, payload.seletor3)
    if (res.status === 200) {
      const metadata = res.data
      return metadata
    }
  } catch (e) {
    throw e
  }
}
const getExpressionMetric = async({ commit }, expression) => {
  try {
    const backEnd = ExpressionMetadata.build({})
    return await backEnd.getMetric(expression)
  } catch (e) {
    throw e
  }
}
const getExpressionYear = async({ commit }, expression) => {
  try {
    const backEnd = ExpressionMetadata.build({})
    return await backEnd.getYear(expression)
  } catch (e) {
    throw e
  }
}

export default {
  getExpressionByMetadata,
  getExpressionMetadata,
  getExpressionMetadataByIdExpression,
  getExpressionByMetadataMultiSelect,
  getExpressionByMetadataSingleSelect,
  getIdExpByMetaData,
  getExpressionMetric,
  getExpressionYear
}
